import React from 'react';
import { Flex } from './Flex';
import { Text } from './Text';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'className'> {
  options: SelectOption[];
  error?: boolean;
  errorMessage?: string;
  label?: string;
}

export const Select: React.FC<SelectProps> = ({
  options,
  error = false,
  errorMessage,
  label,
  ...props
}) => {
  const baseStyles =
    'bg-white/5 rounded-lg border px-4 py-2.5 text-sm text-white transition-all focus:outline-none focus:ring-2 focus:ring-[#3b82f6]/10 cursor-pointer';
  
  const errorStyles = error
    ? 'border-[#fca5a5] focus:border-[#fca5a5]/50'
    : 'border-white/10 focus:border-[#3b82f6]/50 focus:bg-white/8';

  const selectElement = (
    <select
      className={`${baseStyles} ${errorStyles}`}
      {...props}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );

  if (label) {
    return (
      <Flex direction="col">
        <Text variant="label" mb={1}>{label}</Text>
        {selectElement}
        {error && errorMessage && (
          <Text variant="error" size="xs" mt={1}>{errorMessage}</Text>
        )}
      </Flex>
    );
  }

  return (
    <Flex direction="col">
      {selectElement}
      {error && errorMessage && (
        <Text variant="error" size="xs" mt={1}>{errorMessage}</Text>
      )}
    </Flex>
  );
};

